"use strict";

import CardView from "/js/card-views/card-view.js";
import AppUtil from "/js/util/app-util.js";

/**
 * Lesson summary card. Displays a small image at the top followed by ~3 blocks of text.
 */
export default class SummaryCardView extends CardView {
  
  static _TEMPLATE_STRING = `
      <img class='img' src='<%= image %>' alt="">
      <div class='caption'><%= caption %></div>
      <div class='text' style='top:<%=textY %>px;'><%= text %></div>
      <div class='dot'></div>
      `;
  static _template = _.template(SummaryCardView._TEMPLATE_STRING);

  makeContent() {
    const o = {};
    o.image = AppUtil.makeLessonAssetPath(this.data.image.url);
    o.caption = this.data.image.caption;
    o.textY = 8 + o.imageHeight - 8;  // overlaps by 8px on purpose
    o.text = CardView.makeHtmlFromJsonTextArray(this.data);
    return SummaryCardView._template(o);
  }


}
